import { Component, OnInit, Input, ElementRef, OnChanges, OnDestroy, HostListener } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { ProductsService } from 'src/app/services/catalogs-services/products-services/products.service';
import * as moment from 'moment';

@Component({
  selector: 'app-catalogs-product-info-card',
  templateUrl: './catalogs-product-info-card.component.html',
  styleUrls: ['./catalogs-product-info-card.component.scss']
})
export class CatalogsProductInfoCardComponent implements OnInit, OnChanges, OnDestroy {

  @Input() product;
  editingLocked;
  updateProductInfoSubcription: Subscription;
  basicDataForm = new FormGroup({
    active: new FormControl({ value: null, disabled: true }),
    gtin: new FormControl({ value: null, disabled: true }, Validators.required),
    internalCode: new FormControl({ value: null, disabled: true }, Validators.required),
    description: new FormControl({ value: null, disabled: true }, Validators.required),
    tradename: new FormControl({ value: null, disabled: true }, Validators.required),
    category: new FormControl({ value: null, disabled: true }, Validators.required),
    categoryCode: new FormControl({ value: null, disabled: true }, Validators.required),
    additionalInfo: new FormControl({ value: null, disabled: true }, Validators.required),
  });
  updateProductInfoSubscription: Subscription;

  constructor(private productsService: ProductsService,
              private snackbarService: SnackBarService,
              private eRef: ElementRef) {
                this.editingLocked = true;
              }

  ngOnInit() { }

  ngOnChanges() {
    if (this.product) {
      this.resetForm();
    }
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.eRef.nativeElement.contains(event.target)) {
    } else {
      if (event.path[0].className !== 'mat-option-text') {
        if (this.product && !this.editingLocked) {
          this.resetForm();
          this.lockEdition();
        }
      }
    }
  }

  public toggleEdition() {
    if (this.editingLocked) {
      this.unlockEdition();
    } else {
      const validation = this.validateForm();
      if (validation === true) {
        this.submitForm();
        this.lockEdition();
      }
    }
  }

  public submitForm() {
    const validation = this.validateForm();
    if (validation) {
      this.updateProductInfoSubscription = this.productsService.updateProductInfo(this.product.InternalId, this.basicDataForm).subscribe(
        (res) => {
          this.editingLocked = true;
          this.snackbarService.open('catalogs-page.snackbar messages.update product success', 'success');
          this.productsService.refreshProduct();
        },
        (error) => {
          this.snackbarService.open(error['error']['message'], 'error');
          this.productsService.refreshProduct();
        }
      );
    } else {
      this.snackbarService.open(validation, 'error');
    }
  }

  public validateForm() {
    if (!this.basicDataForm.get('gtin').valid) {
      return 'catalogs-page.snackbar messages.gtin products error';
    } else if (!this.basicDataForm.get('description').valid) {
      return 'catalogs-page.snackbar messages.description products error';
    } else {
      return true;
    }
  }

  public resetForm() {
    this.basicDataForm.patchValue({
      active: this.product.Active,
      gtin: this.product.Gtin,
      internalCode: this.product.InternalCode,
      description: this.product.Description,
      tradename: this.product.Tradename,
      category: this.product.Category,
      categoryCode: this.product.CategoryCode,
      additionalInfo: this.product.AdditionalInfo
    });
  }

  public unlockEdition() {
    this.basicDataForm.get('active').enable();
    this.basicDataForm.get('gtin').enable();
    this.basicDataForm.get('internalCode').enable();
    this.basicDataForm.get('description').enable();
    this.basicDataForm.get('tradename').enable();
    this.basicDataForm.get('category').enable();
    this.basicDataForm.get('categoryCode').enable();
    this.basicDataForm.get('additionalInfo').enable();
    this.editingLocked = false;
  }

  public lockEdition() {
    this.basicDataForm.get('active').disable();
    this.basicDataForm.get('gtin').disable();
    this.basicDataForm.get('internalCode').disable();
    this.basicDataForm.get('description').disable();
    this.basicDataForm.get('tradename').disable();
    this.basicDataForm.get('category').disable();
    this.basicDataForm.get('categoryCode').disable();
    this.basicDataForm.get('additionalInfo').disable();
    this.editingLocked = true;
  }

  public generateCodes() {
    const timestamp = moment().valueOf();
    this.basicDataForm.patchValue({
      gtin: timestamp.toString(),
      internalCode: timestamp.toString() + 'i'
    });
  }

  ngOnDestroy() {
    if (this.updateProductInfoSubscription) { this.updateProductInfoSubscription.unsubscribe(); }
  }

}
